module.exports = __webpack_public_path__ + "media/images/emblems/Vullierens-coat_of_arms-9f8dc4e1e3ef44c896df9cfc3551d1ed.svg";